import { useLoaderData } from "react-router-dom";
import "../assets/css/DocumentViewer.css";
import "../assets/css/FullPageLoader.css";
import { useEffect, useState } from "react";
import { useApi } from "../Providers/ApiProvider";

interface DocumentViewerProps {
  addBreadcrumbMapping: (MachineName: string, HumanName: string) => void;
}

export function DocumentViewer(props: DocumentViewerProps) {
  let api = useApi();
  const loader: any = useLoaderData();
  let [document, setDocument] = useState<any>();

  useEffect(() => {
    let blobbyUrl: string;

    if (loader.docid !== undefined) {
      (async () => {
        if (loader.docid != undefined) {
          let doc = await api.General.getDocument(
            loader.ident,
            loader.docid,
            loader.filename,
          );

          props.addBreadcrumbMapping(loader.docid, "View");

          blobbyUrl = window.URL.createObjectURL(doc);
          setDocument(blobbyUrl);
        }

        if (loader.wfid != undefined) {
          let doc = await api.General.getWorkflow(loader.ident, loader.wfid);
          blobbyUrl = window.URL.createObjectURL(doc);
          setDocument(blobbyUrl);
        }
      })();
    } else if (loader.path !== undefined) {
      (async () => {
        let doc = await api.General.getDocumentByPath(loader.path);

        props.addBreadcrumbMapping(loader.path, "View");

        blobbyUrl = window.URL.createObjectURL(doc);
        setDocument(blobbyUrl);
      })();
    }

    return () => {
      if (blobbyUrl) window.URL.revokeObjectURL(blobbyUrl);
    };
  }, []);

  if (document == undefined) {
    return (
      <div className="FullPageLoader">
        <div className="LoadingLabel">Loading...</div>
        <div className="mosaic-loader">
          <div className="cell cell1"></div>
          <div className="cell cell2"></div>
          <div className="cell cell3"></div>
          <div className="cell cell4"></div>
          <div className="cell cell5"></div>
          <div className="cell cell6"></div>
          <div className="cell cell7"></div>
          <div className="cell cell8"></div>
          <div className="cell cell9"></div>
          <div className="cell cell10"></div>
          <div className="cell cell11"></div>
          <div className="cell cell12"></div>
          <div className="cell cell13"></div>
          <div className="cell cell14"></div>
          <div className="cell cell15"></div>
          <div className="cell cell16"></div>
        </div>
      </div>
    );
  } else if (loader.filename === "jpg" || loader.filename === "jpeg") {
    return (
      <div className="DocView_Main">
        <img src={document}></img>
      </div>
    );
  } else {
    return (
      <div className="DocView_Main">
        <object
          // title="PDF of Document"
          className="DocView_Item"
          type="application/pdf"
          data={document}
        ></object>
      </div>
    );
  }
}
